/*!
 * pmk167
 * (c) 2019 kirsites <kirsites@gmail.com>
 * licensed under the MIT license
 */

(function () {

    if (!$('.services-grid').length) return;

    let $mobileCarousel = $('.services-carousel__list');
    let $buttons = $mobileCarousel.closest('.services-block').find('.services-block__controls');
    $('.service-item').clone().appendTo($mobileCarousel);

    tns({
        container: $mobileCarousel[0],
        controlsContainer: $buttons[0],
        items: 1,
        loop : true,
        nav  : false,
    });

})();
